import sanitizeHtml from 'sanitize-html';

/**
 * Utility method for escaping the HTML content so that it is rendered as plain
 * text instead of parsed HTML.
 * @see {@link https://www.npmjs.com/package/sanitize-html#what-if-i-want-disallowed-tags-to-be-escaped-rather-than-discarded}
 *
 *
 * @param {string} dirty - content containing HTML content
 * @param {object} options - config object for sanitizing the content
 * @param {recursiveEscape|discard|escape} [options.disallowedTagsMode=recursiveEscape] - escape HTML tags mode
 * @param {array} [options.allowedTags=[]] - allowed HTML tags to exclude from escaping
 * @param {array} [options.allowedAttributes=[]] - allowed HTML attributes to exclude from escaping
 *
 * @returns the sanitize value with HTML tags escaped
 */
export function escapeHtmlContent(
  dirty,
  {
    disallowedTagsMode = 'recursiveEscape',
    allowedTags = [],
    allowedAttributes = [],
  } = {},
) {
  return sanitizeHtml(dirty, {
    disallowedTagsMode,
    allowedTags,
    allowedAttributes,
  });
}
